import { OrderReportType } from '@/shared/config';

import {
  CoinPayableOrderReportType,
  ORDER_REPORT_TYPE_SERVICE_TYPES,
} from '../config';

export const isCoinPayableOrderReportType = (
  reportType: OrderReportType,
): reportType is CoinPayableOrderReportType =>
  reportType in ORDER_REPORT_TYPE_SERVICE_TYPES;
